// extracted by mini-css-extract-plugin
export var adCard = "_pa-8";
export var adCardBorder = "_pa-5";
export var arbiterButtonIcon = "_pa-p";
export var buttonIcon = "_pa-o";
export var container = "_pa-e";
export var copyButton = "_pa-m";
export var darkGrey = "_pa-u";
export var deliveryDate = "_pa-2";
export var divider = "_pa-n";
export var editModeWrapper = "_pa-7";
export var empty = "_pa-a";
export var errorIcon = "_pa-d";
export var filledCircle = "_pa-4";
export var fulfillmentFooter = "_pa-j";
export var grey = "_pa-s";
export var header = "_pa-i";
export var headerWrapper = "_pa-h";
export var highlighted = "_pa-6";
export var historyEntry = "_pa-3";
export var mobileColumn = "_pa-v";
export var mobileColumnReverse = "_pa-w";
export var orderDetailsContainer = "_pa-g";
export var orderMetadata = "_pa-l";
export var orderMetadataWrapper = "_pa-k";
export var packagesContainer = "_pa-b";
export var product = "_pa-y";
export var productImage = "_pa-z";
export var productInfo = "_pa-x";
export var productTitle = "_pa-10";
export var strikethrough = "_pa-t";
export var tinyText = "_pa-r";
export var title = "_pa-9";
export var trackerCard = "_pa-1";
export var trackerCardWrapper = "_pa-0";
export var trackingContainer = "_pa-f";
export var trackingTitle = "_pa-c";
export var xTinyText = "_pa-q";